import { render, staticRenderFns } from "./QuotationsView.vue?vue&type=template&id=a178312e&scoped=true"
import script from "./QuotationsView.vue?vue&type=script&lang=js"
export * from "./QuotationsView.vue?vue&type=script&lang=js"
import style0 from "./QuotationsView.vue?vue&type=style&index=0&id=a178312e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a178312e",
  null
  
)

export default component.exports